import VueRouter from 'vue-router'
import Vue from 'vue'

Vue.use(VueRouter)
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

const overview = () => import('@/components/bodyOverview/bodyOverview.vue')
const product = () => import('@/components/bodyProduct/bodyProduct.vue')
const about = () => import('@/components/bodyAbout/bodyAbout.vue')
const admin = () => import('@/components/adminPage/adminPage.vue')
const infoEdit = () => import('@/components/adminPage/infoEdit.vue')
const activeManage = () => import('@/components/adminPage/activeManage.vue')
const recruitManage = () => import('@/components/adminPage/recruitManage.vue')
const userManage = () => import('@/components/adminPage/userManage.vue')
const recruitList = () => import('@/components/recruitPage/recruitList.vue')
const recruitDetail = () => import('@/components/recruitPage/recruitDetail.vue')
const resumeDelivery = () => import('@/components/recruitPage/resumeDelivery.vue')
const newsDetail = () => import('@/components/bodyOverview/newsDetail.vue')
const cpuLingyu = () => import('@/components/bodyProduct/cpuLingyu.vue')
const ipProduct = () => import('@/components/bodyProduct/ipProduct.vue')

const index = () => import('@/components/index.vue')
const newsManage = () => import('@/components/adminPage/newsManage.vue')
const baseInfo = () => import('@/components/adminPage/baseInfo.vue')
const resumeList = () => import('@/components/adminPage/resumeList.vue')
const recruitLinkExam = () => import('@/components/adminPage/recruitLinkExam.vue')
const NotFound = () => import('@/components/common/NotFound.vue')
const privatePage = () => import('@/components/recruitPage/privatePage.vue')
const downloadPage = () => import('@/components/docPage/downloadPage.vue')

const routes = [{
    path: '',
    redirect: '/index',
}, {
    name: 'index',
    path: '/index',
    component: index,
    redirect: '/overview',
    //  写入子模块
    children: [{
        name: 'NotFound',
        path: '/NotFound',
        component: NotFound
    }, {
        name: 'overview',
        path: '/overview',
        component: overview
    }, {
        name: 'product',
        path: '/product',
        component: product,
        redirect: '/product/cpu/lingyu',
        //  写入子模块
        children: [
            {
                path: '/product/cpu/lingyu',
                component: cpuLingyu,
            },
            {
                path: '/product/ip/product',
                component: ipProduct,
            }
        ]
    }, {
        name: 'about',
        path: '/about',
        component: about
    }, {
        name: 'recruitList',
        path: '/recruitList',
        component: recruitList
    }, {
        name: 'resumeDelivery',
        path: '/resumeDelivery',
        component: resumeDelivery
    }, {
        name: 'recruitDetail',
        path: '/recruitDetail',
        component: recruitDetail
    }, {
        name: 'newsDetail',
        path: '/newsDetail',
        component: newsDetail
    }, {
        name: 'downloadPage',
        path: '/download',
        component: downloadPage
    }]
}, {
    name: 'private',
    path: '/private',
    component: privatePage
}, {
    name: 'admin',
    path: '/admin',
    component: admin,
    children: [{
        path: '/admin/infoEdit',
        component: infoEdit,
    }, {
        path: '/admin/recruitManage',
        component: recruitManage,
    }, {
        path: '/admin/userManage',
        component: userManage,
    }, {
        path: '/admin/newsManage',
        component: newsManage,
    }, {
        path: '/admin/activeManage',
        component: activeManage,
    }, {
        path: '/admin/baseInfo',
        component: baseInfo,
    }, {
        path: '/admin/resumeList',
        component: resumeList,
    }, {
        path: '/admin/recruitLinkExam',
        component: recruitLinkExam,
    }]
}, {
    path: '*',
    redirect: '/NotFound'
}]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        console.log(to, from, savedPosition)
        if (to.hash) {
            return {
                selector: to.hash
            }
        } else {
            window.scrollTo(0, 0);
        }
    }
})

function getRoutesList(routes, pre) {
    return routes.reduce((array, route) => {
        const path = `${pre}${route.path}`;

        if (route.path !== '*' && !route.path.includes('admin')) {
            array.push(path);
        }

        if (route.children) {
            array.push(...getRoutesList(route.children, pre));
        }

        return array;
    }, []);
}


// getRoutesList(router.options.routes, 'https://zigamiklic.com');
function getRoutesXML() {
    const list = getRoutesList(router.options.routes, 'https://rivai-ic.com.cn')
        .map(route => `<url><loc>${route}</loc></url>`)
        .join('\r\n');
    console.log('getRoutesXML() finished:', list);
    return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
      ${list}
    </urlset>`;
}

getRoutesXML()
// console.log(getRoutesXML())

export default router